/**
 * CountdownDisplay — Compact pills showing visible countdowns with urgency coloring.
 */

import { Timer } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { Countdown } from '@omen-quest/stretch-engine';

interface CountdownDisplayProps {
  countdowns: Countdown[];
  className?: string;
}

export function CountdownDisplay({ countdowns, className }: CountdownDisplayProps) {
  const visible = countdowns.filter(c => c.visible);
  if (visible.length === 0) return null;

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {visible.map(countdown => (
        <div
          key={countdown.id}
          className={cn(
            'flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border',
            countdown.remainingStretches <= 1
              ? 'bg-red-950/40 text-red-400 border-red-800/40'
              : countdown.remainingStretches <= 3
              ? 'bg-amber-950/40 text-amber-400 border-amber-800/40'
              : 'bg-neutral-800/60 text-neutral-300 border-neutral-700/40',
          )}
        >
          <Timer className="w-3 h-3" />
          <span>{countdown.label}</span>
          <span className="text-neutral-500">
            {countdown.remainingStretches}
          </span>
        </div>
      ))}
    </div>
  );
}
